module.exports = __webpack_public_path__ + "VIPV40.png?55c883afce2002370ed4e1b89f3be7fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV40.png
// module id = 137
// module chunks = 0